<template>
    <v-layout fill-height row justify-center :class="flexClass">
        <v-progress-linear :indeterminate="true" v-if="progressBarVisible" class="ma-0 pa-0 progress-top"></v-progress-linear>
        <v-flex sm12 lg12 p-0>
            <v-card class="fill-height">
                <v-breadcrumbs :items="breadCrumbs" class="dense">
                    <template v-slot:divider>
                        <v-icon>forward</v-icon>
                    </template>
                </v-breadcrumbs>

                <v-tabs v-model="tab">
                    <v-tab>
                        <v-icon left>mdi-view-sequential</v-icon> {{ $t("lumber") }}
                    </v-tab>
                    <v-tab-item>
                        <v-toolbar card prominent dense>
                            <v-text-field
                                class="search-field"
                                v-on:keyup.space="spaceClickedInSearch()"
                                v-model="lumberSearch"
                                prepend-icon="search"
                                :label="$t('searchLumber')"
                                single-line
                                hide-details
                                clearable
                            ></v-text-field>

                            <v-tooltip
                                bottom
                                :disabled="true"
                            >
                                <template v-slot:activator="{ on }">
                                    <v-btn
                                        flat
                                        v-on="on"
                                        @click="reloadLumbers"
                                    >
                                        <v-icon>mdi-reload</v-icon> {{ $t("reload") }}
                                    </v-btn>
                                </template>
                                <span>{{ $t("reload") }}</span>
                            </v-tooltip>
                            <v-tooltip
                                bottom
                                :disabled="true"
                            >
                                <template v-slot:activator="{ on }">
                                    <v-btn
                                        flat
                                        v-on="on"
                                        :disabled="!acl.Create || $store.getters.subscription.settings.lumber.lock"
                                        @click="showNewLumberDlg"
                                    >
                                        <v-icon>mdi-plus-circle-outline</v-icon> {{ $t("create") }}
                                    </v-btn>
                                </template>
                                <span>{{ $t("create") }}</span>
                            </v-tooltip>
                            <v-tooltip
                                bottom
                                :disabled="true"
                            >
                                <template v-slot:activator="{ on }">
                                    <v-btn
                                        flat
                                        v-on="on"
                                        :disabled="!selectedRow || !acl.Modify || $store.getters.subscription.settings.lumber.lock"
                                        @click="editItem(selectedRow)"
                                    >
                                        <v-icon>mdi-pencil-outline</v-icon> {{ $t("edit") }}
                                    </v-btn>
                                </template>
                                <span>{{ $t("edit") }}</span>
                            </v-tooltip>
                            <v-tooltip
                                bottom
                                :disabled="true"
                            >
                                <template v-slot:activator="{ on }">
                                    <v-btn
                                        flat
                                        v-on="on"
                                        :disabled="!selectedRow || !acl.Delete || $store.getters.subscription.settings.lumber.lock"
                                        @click="deleteItemClick(selectedRow)"
                                    >
                                        <v-icon>mdi-delete-outline</v-icon> {{ $t("delete") }}
                                    </v-btn>
                                </template>
                                <span>{{ $t("delete") }}</span>
                            </v-tooltip>
                        </v-toolbar>

                        <v-card-text>
                            <v-container fluid fill-height grid-list-xs pa-0>
                                <v-layout row wrap>
                                    <v-flex xs12 md8 lg9 d-flex pa-0 style="overflow-x: auto;" class="v-scrollable">
                                        <v-data-table
                                            hide-actions
                                            :headers="computedHeaders"
                                            :items="filteredData"
                                            :search="lumberSearch"
                                            class="dense-table no-overflow"
                                        >
                                            <template v-slot:items="props">
                                                <tr
                                                    @click="selectedRow = props.item"
                                                    :class="{'grey darken-5': props.item === selectedRow}"
                                                >
                                                    <td class="text-xs-left">{{ props.item.species }}</td>
                                                    <td class="text-xs-left">{{ props.item.dimension }}</td>
                                                    <td class="text-xs-left">{{ props.item.sawSize }}</td>
                                                    <td class="text-xs-left">{{ props.item.lengthsList }}</td>
                                                    <td class="text-xs-left">{{ props.item.boardType }}</td>
                                                    <td class="text-xs-right">{{ props.item.price }}</td>
                                                    <td class="text-xs-right">{{ props.item.expenses }}</td>
                                                    <!--
                                                    <td class="justify-center layout px-0">
                                                        <v-icon
                                                            class="mr-2"
                                                            @click="editItem(props.item)"
                                                        >
                                                            edit
                                                        </v-icon>
                                                        <v-icon
                                                            @click="deleteItemClick(props.item)"
                                                        >
                                                            delete
                                                        </v-icon>
                                                    </td>
                                                    -->
                                                </tr>
                                            </template>
                                            <template v-slot:no-results>
                                                <v-alert :value="true" color="blue-grey" icon="warning">
                                                    {{ $t("youSearchFor") }}{{ lumberSearch }}{{ $t("foundNoResults") }}.
                                                </v-alert>
                                            </template>
                                        </v-data-table>
                                    </v-flex>
                                    <v-flex xs12 md4 lg3 d-flex py-0 pl-2 class="v-scrollable border-rounded">
                                        <v-sheet
                                            class="grey dense border-rounded"
                                            :class="{'lighten-4': !theme.isDark, 'darken-4': theme.isDark}"
                                            style="overflow: auto;"
                                        >
                                            <v-expansion-panel v-model="filterPanels" expand style="overflow-y: hidden;">
                                                <v-expansion-panel-content
                                                    class="grey"
                                                    :class="{'lighten-4': !theme.isDark, 'darken-4': theme.isDark}"
                                                >
                                                    <template v-slot:header>
                                                        <div class="subheading font-weight-bold">{{ $t("speciesAlt") }}</div>
                                                    </template>
                                                    <v-card
                                                        class="grey"
                                                        :class="{'lighten-4': !theme.isDark, 'darken-4': theme.isDark}"
                                                    >
                                                        <v-card-text class="dense">
                                                            <v-layout row>
                                                                <v-flex xs12d-flex>
                                                                    <v-checkbox
                                                                        v-for="(item, index) in filteredSpecies"
                                                                        v-model="filters.species"
                                                                        :key="index"
                                                                        :value="item.title"
                                                                        :label="item.title"
                                                                    ></v-checkbox>
                                                                </v-flex>
                                                            </v-layout>
                                                        </v-card-text>
                                                    </v-card>
                                                    <v-divider></v-divider>
                                                </v-expansion-panel-content>

                                                <v-expansion-panel-content
                                                    class="grey"
                                                    :class="{'lighten-4': !theme.isDark, 'darken-4': theme.isDark}"
                                                >
                                                    <template v-slot:header>
                                                        <div class="subheading font-weight-bold">{{ $t("boardType") }}</div>
                                                    </template>
                                                    <v-card
                                                        class="grey"
                                                        :class="{'lighten-4': !theme.isDark, 'darken-4': theme.isDark}"
                                                    >
                                                        <v-card-text class="dense">
                                                            <v-layout row>
                                                                <v-flex xs12d-flex>
                                                                    <v-checkbox
                                                                        v-for="(item, index) in boardTypesList"
                                                                        v-model="filters.boardType"
                                                                        :key="index"
                                                                        :value="item.title"
                                                                        :label="item.title"
                                                                    ></v-checkbox>
                                                                </v-flex>
                                                            </v-layout>
                                                        </v-card-text>
                                                    </v-card>
                                                    <v-divider></v-divider>
                                                </v-expansion-panel-content>

                                                <v-expansion-panel-content
                                                    class="grey"
                                                    :class="{'lighten-4': !theme.isDark, 'darken-4': theme.isDark}"
                                                >
                                                    <template v-slot:header>
                                                        <div class="subheading font-weight-bold">{{ $t("lumberGroups") }}</div>
                                                    </template>
                                                    <v-card
                                                        class="grey"
                                                        :class="{'lighten-4': !theme.isDark, 'darken-4': theme.isDark}"
                                                    >
                                                        <v-card-text class="dense">
                                                            <v-layout row>
                                                                <v-flex xs12d-flex>
                                                                    <v-checkbox
                                                                        v-for="(item, index) in groupsList"
                                                                        v-model="filters.groups"
                                                                        :key="index"
                                                                        :value="item.title"
                                                                        :label="item.title"
                                                                    ></v-checkbox>
                                                                </v-flex>
                                                            </v-layout>
                                                        </v-card-text>
                                                    </v-card>
                                                    <v-divider></v-divider>
                                                </v-expansion-panel-content>

                                                <!--
                                                <v-expansion-panel-content
                                                    class="grey"
                                                    :class="{'lighten-4': !theme.isDark, 'darken-4': theme.isDark}"
                                                >
                                                    <template v-slot:header>
                                                        <div class="subheading font-weight-bold">{{ $t("dimension") }}</div>
                                                    </template>
                                                    <v-card
                                                        class="grey"
                                                        :class="{'lighten-4': !theme.isDark, 'darken-4': theme.isDark}"
                                                    >
                                                        <v-card-text class="dense">
                                                            <v-layout row>
                                                                <v-flex xs12d-flex>
                                                                    <template v-for="(item, index) in dimensionsList">
                                                                        <v-checkbox
                                                                            v-model="filters.dimension"
                                                                            :key="index"
                                                                            :value="item.title"
                                                                            :label="item.title"
                                                                        ></v-checkbox>
                                                                    </template>
                                                                </v-flex>
                                                            </v-layout>
                                                        </v-card-text>
                                                    </v-card>
                                                    <v-divider></v-divider>
                                                </v-expansion-panel-content>

                                                <v-expansion-panel-content
                                                    class="grey"
                                                    :class="{'lighten-4': !theme.isDark, 'darken-4': theme.isDark}"
                                                >
                                                    <template v-slot:header>
                                                        <div class="subheading font-weight-bold">{{ $t("sawSize") }}</div>
                                                    </template>
                                                    <v-card
                                                        class="grey"
                                                        :class="{'lighten-4': !theme.isDark, 'darken-4': theme.isDark}"
                                                    >
                                                        <v-card-text class="dense">
                                                            <v-layout row>
                                                                <v-flex xs12d-flex>
                                                                    <template v-for="(item, index) in sawSizesList">
                                                                        <v-checkbox
                                                                            v-model="filters.sawSize"
                                                                            :key="index"
                                                                            :value="item.title"
                                                                            :label="item.title"
                                                                        ></v-checkbox>
                                                                    </template>
                                                                </v-flex>
                                                            </v-layout>
                                                        </v-card-text>
                                                    </v-card>
                                                    <v-divider></v-divider>
                                                </v-expansion-panel-content>
                                                -->
<!--
                                                <v-expansion-panel-content
                                                    class="grey"
                                                    :class="{'lighten-4': !theme.isDark, 'darken-4': theme.isDark}"
                                                >
                                                    <template v-slot:header>
                                                        <div class="subheading font-weight-bold">{{ $t("length") }}</div>
                                                    </template>
                                                    <v-card
                                                        class="grey"
                                                        :class="{'lighten-4': !theme.isDark, 'darken-4': theme.isDark}"
                                                    >
                                                        <v-card-text class="dense">
                                                            <v-layout row>
                                                                <v-flex xs12d-flex>
                                                                    <v-checkbox
                                                                        v-for="(item, index) in lengthsList"
                                                                        v-model="filters.lengths"
                                                                        :key="index"
                                                                        :value="item.title"
                                                                        :label="item.title"
                                                                    ></v-checkbox>
                                                                </v-flex>
                                                            </v-layout>
                                                        </v-card-text>
                                                    </v-card>
                                                    <v-divider></v-divider>
                                                </v-expansion-panel-content> -->

                                                <!--
                                                <v-expansion-panel-content
                                                    class="grey"
                                                    :class="{'lighten-4': !theme.isDark, 'darken-4': theme.isDark}"
                                                >
                                                    <template v-slot:header>
                                                        <div class="subheading font-weight-bold">{{ $t("priceM3") }}</div>
                                                    </template>
                                                    <v-card
                                                        class="grey"
                                                        :class="{'lighten-4': !theme.isDark, 'darken-4': theme.isDark}"
                                                    >
                                                        <v-card-text class="dense">
                                                            <v-layout row>
                                                                <v-flex xs12d-flex>
                                                                    <template v-for="(item, index) in priceList">
                                                                        <v-checkbox
                                                                            v-model="filters.price"
                                                                            :key="index"
                                                                            :value="item.title"
                                                                            :label="item.title.toString()"
                                                                        ></v-checkbox>
                                                                    </template>
                                                                </v-flex>
                                                            </v-layout>
                                                        </v-card-text>
                                                    </v-card>
                                                    <v-divider></v-divider>
                                                </v-expansion-panel-content>
                                                -->
                                            </v-expansion-panel>

                                            <v-expansion-panel v-model="filterButtons" class="filterButtons" readonly expand style="overflow-y: hidden;">
                                                <v-expansion-panel-content
                                                    class="grey"
                                                    :class="{'lighten-4': !theme.isDark, 'darken-4': theme.isDark}"
                                                    hide-actions
                                                >
                                                    <v-card
                                                        class="grey"
                                                        :class="{'lighten-4': !theme.isDark, 'darken-4': theme.isDark}"
                                                    >
                                                        <v-card-text class="dense">
                                                            <v-layout row>
                                                                <v-flex xs12d-flex>
                                                                    <v-btn block color="success" v-if="false">{{ $t("apply") }}</v-btn>
                                                                    <v-btn block color="warning" @click="resetFilters">{{ $t("reset") }}</v-btn>
                                                                </v-flex>
                                                            </v-layout>
                                                        </v-card-text>
                                                    </v-card>
                                                    <v-divider></v-divider>
                                                </v-expansion-panel-content>
                                            </v-expansion-panel>
                                        </v-sheet>
                                    </v-flex>
                                </v-layout>
                            </v-container>
                        </v-card-text>
                    </v-tab-item>

                    <v-tab>
                        <v-icon left>mdi-view-module</v-icon> {{ $t("lumberGroups") }}
                    </v-tab>
                    <v-tab-item>
                        <v-card-text class="pt-0">
                            <v-layout wrap dense>
                                <v-flex xs6 pr-2>
                                    <v-select
                                        :items="filteredSpecies"
                                        item-text="title"
                                        item-value="id"
                                        prepend-icon="mdi-pine-tree"
                                        v-model="selectedSpeciesId"
                                        :label="$t('speciesAlt')"
                                        dense
                                        hide-details
                                    ></v-select>
                                </v-flex>
                                <v-flex xs6>
                                    <v-select
                                        :items="filteredGroups"
                                        item-text="name"
                                        item-value="id"
                                        prepend-icon="mdi-view-module"
                                        v-model="selectedGroupId"
                                        :label="$t('lumberGroup')"
                                        dense
                                        hide-details
                                    ></v-select>
                                </v-flex>
                            </v-layout>
                        </v-card-text>
                        <v-toolbar card prominent dense>
                            <v-text-field
                                class="search-field"
                                v-on:keyup.space="spaceClickedInSearch()"
                                v-model="lumberSearch"
                                prepend-icon="search"
                                :label="$t('searchLumber')"
                                single-line
                                hide-details
                                clearable
                            ></v-text-field>

                            <v-tooltip
                                bottom
                                :disabled="true"
                            >
                                <template v-slot:activator="{ on }">
                                    <v-btn
                                        flat
                                        v-on="on"
                                        :disabled="!acl.Create || $store.getters.subscription.settings.lumber.lock || selectedGroupId == 0 || selectedGroupId == null"
                                        @click="saveGroupClick(null)"
                                    >
                                        <v-icon>mdi-content-save-outline</v-icon> {{ $t("save") }}
                                    </v-btn>
                                </template>
                                <span>{{ $t("save") }}</span>
                            </v-tooltip>
                            <v-tooltip
                                bottom
                                :disabled="true"
                            >
                                <template v-slot:activator="{ on }">
                                    <v-btn
                                        flat
                                        v-on="on"
                                        :disabled="!acl.Modify || $store.getters.subscription.settings.lumber.lock || selectedSpeciesId == null"
                                        @click="saveGroupAsClick"
                                    >
                                        <v-icon>mdi-content-save-edit-outline</v-icon> {{ $t("saveAs") }}
                                    </v-btn>
                                </template>
                                <span>{{ $t("saveAs") }}</span>
                            </v-tooltip>
                            <v-tooltip
                                bottom
                                :disabled="true"
                            >
                                <template v-slot:activator="{ on }">
                                    <v-btn
                                        flat
                                        v-on="on"
                                        :disabled="groupItems.length == 0 || !acl.Modify || $store.getters.subscription.settings.lumber.lock || selectedGroupId == 0"
                                        @click="editGroupClick"
                                    >
                                        <v-icon>mdi-pencil-outline</v-icon> {{ $t("rename") }}
                                    </v-btn>
                                </template>
                                <span>{{ $t("rename") }}</span>
                            </v-tooltip>
                            <v-tooltip
                                bottom
                                :disabled="true"
                            >
                                <template v-slot:activator="{ on }">
                                    <v-btn
                                        flat
                                        v-on="on"
                                        :disabled="selectedGroupId == 0 || selectedGroupId == null || !acl.Delete || $store.getters.subscription.settings.lumber.lock"
                                        @click="deleteGroupClick"
                                    >
                                        <v-icon>mdi-delete-outline</v-icon> {{ $t("delete") }}
                                    </v-btn>
                                </template>
                                <span>{{ $t("delete") }}</span>
                            </v-tooltip>
                        </v-toolbar>

                        <v-card-text>
                            <v-container fluid fill-height grid-list-xs pa-0>
                                <v-layout row wrap>
                                    <v-flex xs12 style="overflow-x: auto;" class="v-scrollable-groups">
                                        <v-data-table
                                            hide-actions
                                            select-all
                                            :headers="computedGroupsHeaders"
                                            :items="filteredLumber"
                                            :pagination.sync="pagination"
                                            :search="lumberSearch"
                                            item-key="id"
                                            v-model="groupItems"
                                            class="dense-table no-overflow"
                                        >
                                            <template v-slot:headers="props">
                                                <tr>
                                                    <th>
                                                        <v-checkbox
                                                            :input-value="props.all"
                                                            :indeterminate="props.indeterminate"
                                                            primary
                                                            hide-details
                                                            @click.stop="toggleAll"
                                                        ></v-checkbox>
                                                    </th>
                                                    <th
                                                        v-for="header in props.headers"
                                                        :key="header.text"
                                                        :align="header.align"
                                                        :class="['column sortable', pagination.descending ? 'desc' : 'asc', header.value === pagination.sortBy ? 'active' : '']"
                                                        @click="changeSort(header.value)"
                                                    >
                                                        {{ header.text }}
                                                        <v-icon small>arrow_upward</v-icon>
                                                    </th>
                                                </tr>
                                            </template>
                                            <template v-slot:items="props">
                                                <td>
                                                    <v-checkbox
                                                        v-model="props.selected"
                                                        primary
                                                        hide-details
                                                    ></v-checkbox>
                                                </td>
                                                <!--
                                                <td class="text-xs-left">{{ props.item.species }}</td>
                                                -->
                                                <td class="text-xs-left">{{ props.item.dimension }}</td>
                                                <td class="text-xs-left">{{ props.item.sawSize }}</td>
                                                <td class="text-xs-left">{{ props.item.lengthsList }}</td>
                                                <td class="text-xs-left">{{ props.item.boardType }}</td>
                                                <td class="text-xs-right">{{ props.item.price }}</td>
                                                <td class="text-xs-right">{{ props.item.expenses }}</td>
                                                <!--
                                                <td class="justify-center layout px-0">
                                                    <v-icon
                                                        class="mr-2"
                                                        @click="editItem(props.item)"
                                                    >
                                                        edit
                                                    </v-icon>
                                                    <v-icon
                                                        @click="deleteItemClick(props.item)"
                                                    >
                                                        delete
                                                    </v-icon>
                                                </td>
                                                -->
                                            </template>
                                            <template v-slot:no-results>
                                                <v-alert :value="true" color="blue-grey" icon="warning">
                                                    {{ $t("youSearchFor") }}{{ lumberSearch  }}{{ $t("foundNoResults") }}.
                                                </v-alert>
                                            </template>
                                        </v-data-table>
                                    </v-flex>

                                </v-layout>
                            </v-container>
                        </v-card-text>
                    </v-tab-item>
                </v-tabs>
            </v-card>
            <edit-lumber-dialog ref="EditLumberDialog"/>
            <message-box        ref="MessageBox"/>
            <message-dialog     ref="MessageDialog"/>
            <text-input-dialog  ref="TextInputDialog"/>
        </v-flex>
        <v-alert
            :value="alert !== ''"
            :type="alertType"
            transition="scale-transition"
            class="bottom-alert"
        >
            {{ alert }}
        </v-alert>
    </v-layout>
</template>

<script>
    import EditLumberDialog from "@/components/dialogs/EditLumberDialog";
    import MessageBox       from "@/components/dialogs/MessageBox";
    import MessageDialog    from "@/components/dialogs/MessageDialog";
    import TextInputDialog  from "@/components/dialogs/TextInputDialog";

    export default {
        name: "LumberManagement",

        inject: ["theme"],

        components: {
            EditLumberDialog,
            MessageBox,
            MessageDialog,
            TextInputDialog,
        },

        data () {
            return {
                acl: {
                    Read:   false,
                    Create: false,
                    Modify: false,
                    Export: false,
                    Delete: false
                },
                breadCrumbs: [
                    { text: "Справочники",   disabled: false },
                    { text: "Пиломатериалы", disabled: false }
                ],
                lumber: [],
                headers: [
                    { text: "id",             value: "id",        align: "center", sortable: true },
                    { text: "speciesId",      value: "speciesId", align: "center", sortable: true },
                    { text: "Tn",             value: "Tn",        align: "center", sortable: true },
                    { text: "Wn",             value: "Wn",        align: "center", sortable: true },
                    { text: "Ts",             value: "Ts",        align: "center", sortable: true },
                    { text: "Ws",             value: "Ws",        align: "center", sortable: true },
                    { text: "Порода",         value: "species",   align: "left",   sortable: true },
                    { text: "Сечение",        value: "dimension", align: "left",   sortable: true },
                    { text: "Пильный размер", value: "sawSize",   align: "left",   sortable: true },
                    { text: "Длина, м",       value: "lengths",   align: "left",   sortable: false },
                    { text: "Тип доски",      value: "boardType", align: "left",   sortable: true },
                    { text: "Цена за м3",     value: "price",     align: "right",  sortable: true },
                    { text: "Затраты на м3",  value: "expenses",  align: "right",  sortable: true } //,
                    //{ text: "Действие",       value: "action",    align: "center", sortable: false }
                ],
                hideIDs: true,

                loading: {
                    groups:  false,
                    lengths: false,
                    lumber:  false,
                    species: false
                },

                tab: 0,

                search: "",
                selected:    [],
                selectedRow: null,

                filterPanels:  [true, true, true, true, true, true],
                filterButtons: 0,

                boardTypesList: [],
                dimensionsList: [],
                groupsList:     [],
                lengthsList:    [],
                priceList:      [],
                sawSizesList:   [],
                speciesList:    [],

                groupsFilters: {
                    boardType: [],
                    dimension: [],
                    lengths:   [],
                    //price:     [],
                    //sawSize:   [],
                    species:   []
                },
                filters: {
                    boardType: [],
                    dimension: [],
                    lengths:   [],
                    //price:     [],
                    //sawSize:   [],
                    species:   [],
                    groups:    []
                },
                alert:         "",
                alertType:     "success",
                lumberSearch:  "",
                dialogWatcher: null,
                lumberWatcher: null,

                //species:         [],
                selectedSpeciesId: null,

                groups:           [],
                groupItems:       [],
                groupItemsBackup: [],
                selectedGroupId:  null,
                enableToUpdateGroupList:    true,

                pagination: {
                    sortBy:      "boardType",
                    descending:  false,
                    rowsPerPage: -1,
                },
            }
        },

        computed: {
            computedHeaders () {
                return !this.hideIDs
                    ? this.headers
                    : this.headers.filter(
                        header => header.value !== "id"
                            && header.value !== "speciesId"
                            && header.value !== "Tn"
                            && header.value !== "Wn"
                            && header.value !== "Ts"
                            && header.value !== "Ws"
                    );
            },

            computedGroupsHeaders () {
                return !this.hideIDs
                    ? this.headers
                    : this.headers.filter(
                        header => header.value !== "id"
                            && header.value !== "speciesId"
                            && header.value !== "species"
                            && header.value !== "Tn"
                            && header.value !== "Wn"
                            && header.value !== "Ts"
                            && header.value !== "Ws"
                    );
            },

            filteredData () {
                return this.lumber.filter(data => {
                    return Object.keys(this.filters).every(filter => {
                        if (filter == "lengths") {
                            let result = this.filters[filter].length == 0 ? true : false;

                            this.filters[filter].forEach(elm => {
                                let searchFor = elm.trim().indexOf(" ") > 0
                                    ? elm.substring(0, elm.trim().indexOf(" "))
                                    : elm;

                                if (data.lengthsList.indexOf(searchFor) >= 0) { result = true; }
                            });
                            return result;
                        } else if (filter == "groups") {
                            let result = this.filters[filter].length == 0 ? true : false;
                            this.filters[filter].forEach(elm => {
                                if (data.groups.indexOf(elm) >= 0) { result = true; }
                            });
                            return result;
                        } else {
                            return this.filters[filter].length < 1 || this.filters[filter].includes(data[filter])
                        }
                    });
                });
            },

            filteredGroups () {
                return this.groups.filter(data => data.speciesId == this.selectedSpeciesId);
            },

            filteredLumber () {
                return this.lumber.filter(data => {
                    return Object.keys(this.groupsFilters).every(filter => {
                        if (filter == "lengths") {
                            let result = this.groupsFilters[filter].length == 0 ? true : false;

                            this.groupsFilters[filter].forEach(elm => {
                                let searchFor = elm.trim().indexOf(" ") > 0
                                    ? elm.substring(0, elm.trim().indexOf(" "))
                                    : elm;

                                if (data.lengthsList.indexOf(searchFor) >= 0) { result = true; }
                            });
                            return result;
                        } else if (filter == "species") {
                            return this.groupsFilters[filter].includes(data[filter])
                        } else {
                            return this.groupsFilters[filter].length < 1 || this.groupsFilters[filter].includes(data[filter])
                        }
                    });
                });
            },

            filteredSpecies () {
                return this.speciesList.filter(item => this.$store.getters.user.settings.selectedSpecies.includes(item.id))
            },


            flexClass () {
                return {
                    //lgUp: this.$vuetify.breakpoint.lgAndUp,
                    "md-up": this.$vuetify.breakpoint.mdAndUp
                }
            },

            progressBarVisible () {
                return this.loading.groups || this.loading.lengths || this.loading.lumber || this.loading.species;
            }
        },

        watch: {
            alert: function (val) {
                let component = this;
                if (val !== "") {
                    setTimeout(() => {
                        component.alert = "";
                    }, 3000);
                }
            },

            filteredLumber: function () {
                let ids = this.groups.filter(data => data.id == this.selectedGroupId).length > 0
                    ? this.groups.filter(data => data.id == this.selectedGroupId)[0].lumberIds
                    : [];

                this.groupItems = this.lumber.filter(data => ids.includes(data.id));
            },

            selectedSpeciesId: function (val) {
                this.groupsFilters.species = [ this.speciesList.filter(data => data.id == val)[0].title ];

                if (this.groups.filter(data => data.id == 0 && data.speciesId == val).length == 0) {
                    this.groups.unshift({
                        id:        0,
                        name:      this.$t("newGroup"),
                        speciesId: val,
                        lumberIds: [],
                    });
                }
                this.selectedGroupId = 0;
            },

            selectedGroupId: function (val) {
                let ids = this.groups.filter(data => data.id == val).length > 0
                    ? this.groups.filter(data => data.id == val)[0].lumberIds
                    : [];

                this.groupItems = this.lumber.filter(data => ids.includes(data.id));
                this.groupItemsBackup = [...this.groupItems];
            },
        },

        async mounted () {
            if (!this.$store.getters.user.loggedIn) {
                if (!this.$noRedirect.includes(this.$router.currentRoute.path)) {
                    this.$router.push("/home");
                }
            }

            this.applyLocale();
            this.loadSpecies();
            this.loadLengths();
            await this.loadLumber();
            this.loadGroups();

            if (this.$store.getters.user.acl) {
                this.$store.getters.user.acl.forEach((aclRecord) => {
                    if (aclRecord.Module.Name == "lumber") {
                        this.acl = aclRecord;
                    }
                });
            }

            this.$root.$on("localeChanged", () => { this.applyLocale(); });
        },

        methods: {
            /**
             * Применение локали
             */
            applyLocale () {
                this.headers = [
                    { text: "id",                  value: "id",        align: "center", sortable: true },
                    { text: "speciesId",           value: "speciesId", align: "center", sortable: true },
                    { text: "Tn",                  value: "Tn",        align: "center", sortable: true },
                    { text: "Wn",                  value: "Wn",        align: "center", sortable: true },
                    { text: "Ts",                  value: "Ts",        align: "center", sortable: true },
                    { text: "Ws",                  value: "Ws",        align: "center", sortable: true },
                    { text: this.$t("speciesAlt"), value: "species",   align: "left",   sortable: true },
                    { text: this.$t("dimension"),  value: "dimension", align: "left",   sortable: true },
                    { text: this.$t("sawSize"),    value: "sawSize",   align: "left",   sortable: true },
                    {
                        text:     this.$t("length") + ", " + this.$t("m"),
                        value:    "lengths",
                        align:    "left",
                        sortable: false
                    },
                    { text: this.$t("boardType"),  value: "boardType", align: "left",   sortable: true },
                    { text: this.$t("priceM3"),    value: "price",     align: "right",  sortable: true },
                    { text: this.$t("expensesM3"), value: "expenses",     align: "right",  sortable: true } //,
                    //{ text: this.$t("action"),     value: "action",    align: "center", sortable: false }
                ];

                this.breadCrumbs = [
                    { text: this.$t("catalogs"), disabled: false },
                    { text: this.$t("lumber"),   disabled: false }
                ];

                this.boardTypesList = [
                    { id: 1, title: this.$t("sideBoard") },
                    { id: 2, title: this.$t("centralBoard") }
                ];

                if (this.groups.length > 0) {
                    this.groups[0].name = this.$t("newGroup");
                }
            },

            changeSort (column) {
                if (this.pagination.sortBy === column) {
                    this.pagination.descending = !this.pagination.descending;
                } else {
                    this.pagination.sortBy     = column;
                    this.pagination.descending = false;
                }
            },

            /**
             * Удаление элемента
             */
            deleteItem (item) {
                this.axios({
                    method: "delete",
                    url: `${this.$config.apiURL}lumber/${item.id}/`,
                    withCredentials: true
                }).then(() => {
                    this.reloadLumbers();
                }).catch(error => {
                    if (error.response && error.response.status == 401) {
                        this.showMessageBox(this.$t("error"), this.$t("sessionExpired"));

                        // Удаление наблюдателя если установлен
                        if (this.dialogWatcher !== null) { this.dialogWatcher(); }

                        // Отслеживание нажатия кнопки ok в диалоге
                        this.dialogWatcher = this.$watch(
                            "$refs.MessageBox.dialog",
                            () => { window.location.reload(); }
                        );
                    } else if (error.response && error.response.status == 402) {
                        this.showMessageBox(this.$t("error"), this.$t("cantDeleteLumber") + ". " + this.$t("subscriptionExpired"));

                        // Удаление наблюдателя если установлен
                        if (this.dialogWatcher !== null) { this.dialogWatcher(); }

                        // Отслеживание нажатия кнопки ok в диалоге
                        this.dialogWatcher = this.$watch(
                            "$refs.MessageBox.dialog",
                            () => { this.$emit("doLogout", true); }
                        );
                    } else if (error.response && error.response.status == 403 && typeof error.response.data !== "object" && error.response.data.trim() == "Access denied. Session id mismatch") {
                        this.showMessageBox(this.$t("error"), `${this.$t("accessDenied")}. ${this.$t("sessionIdMismatch")}.`);
                    } else if (error.response && error.response.status == 403) {
                        this.showMessageBox(this.$t("error"), this.$t("cantDeleteLumber") + ". " + this.$t("accessDenied"));
                    } else {
                        this.showMessageBox(this.$t("error"), this.$t("cantDeleteLumber"));
                    }
                });
            },

            /**
             * Обработчик нажатия кнопки удаления элемента
             */
            deleteItemClick (item) {
                // Удаление наблюдателя если установлен
                if (this.dialogWatcher !== null) {
                    this.dialogWatcher();
                }

                /* Отслеживание ответа в диалоге "Да/Нет" */
                this.dialogWatcher = this.$watch(
                    "$refs.MessageDialog.answer",
                    (val) => {
                        if (val) { this.deleteItem(item); }
                    }
                );

                this.$refs.MessageDialog.title       = this.$t("lumberDelete");
                this.$refs.MessageDialog.messageText = this.$t("confirmLumberDelete");
                this.$refs.MessageDialog.dialog      = true;
            },

            /**
             * Удаление элемента
             */
            deleteGroup () {
                this.axios({
                    method: "delete",
                    url: `${this.$config.apiURL}lumber_groups/${this.selectedGroupId}/`,
                    withCredentials: true
                }).then(() => {
                    this.enableToUpdateGroupList = true;
                    this.loadGroups();
                }).catch(error => {
                    if (error.response && error.response.status == 401) {
                        this.showMessageBox(this.$t("error"), this.$t("sessionExpired"));

                        // Удаление наблюдателя если установлен
                        if (this.dialogWatcher !== null) { this.dialogWatcher(); }

                        // Отслеживание нажатия кнопки ok в диалоге
                        this.dialogWatcher = this.$watch(
                            "$refs.MessageBox.dialog",
                            () => { window.location.reload(); }
                        );
                    } else if (error.response && error.response.status == 402) {
                        this.showMessageBox(this.$t("error"), this.$t("cantDeleteLumberGroup") + ". " + this.$t("subscriptionExpired"));

                        // Удаление наблюдателя если установлен
                        if (this.dialogWatcher !== null) { this.dialogWatcher(); }

                        // Отслеживание нажатия кнопки ok в диалоге
                        this.dialogWatcher = this.$watch(
                            "$refs.MessageBox.dialog",
                            () => { this.$emit("doLogout", true); }
                        );
                    } else if (error.response && error.response.status == 403 && typeof error.response.data !== "object" && error.response.data.trim() == "Access denied. Session id mismatch") {
                        this.showMessageBox(this.$t("error"), `${this.$t("accessDenied")}. ${this.$t("sessionIdMismatch")}.`);
                    } else if (error.response && error.response.status == 403) {
                        this.showMessageBox(this.$t("error"), this.$t("cantDeleteLumberGroup") + ". " + this.$t("accessDenied"));
                    } else {
                        this.showMessageBox(this.$t("error"), this.$t("cantDeleteLumberGroup"));
                    }
                });
            },

            /**
             * Обработчик нажатия кнопки удаления группы
             */
            deleteGroupClick () {
                // Удаление наблюдателя если установлен
                if (this.dialogWatcher !== null) {
                    this.dialogWatcher();
                }

                /* Отслеживание ответа в диалоге "Да/Нет" */
                this.dialogWatcher = this.$watch(
                    "$refs.MessageDialog.answer",
                    (val) => {
                        if (val) { this.deleteGroup(); }
                    }
                );

                this.$refs.MessageDialog.title       = this.$t("lumberGroupDelete");
                this.$refs.MessageDialog.messageText = this.$t("confirmLumberGroupDelete");
                this.$refs.MessageDialog.dialog      = true;
            },

            editGroupClick () {
                if (this.dialogWatcher !== null) {
                    this.dialogWatcher();
                }

                this.dialogWatcher = this.$watch(
                    "$refs.TextInputDialog.answer",
                    (val) => {
                        if (val) {
                            if (this.$refs.TextInputDialog.textInput.trim() == "") {
                                this.$refs.MessageBox.title       = this.$t("error");
                                this.$refs.MessageBox.messageText = this.$t("groupNameCantBeEmpty");
                                this.$refs.MessageBox.dialog      = true;
                            } else {
                                this.saveGroupClick(this.$refs.TextInputDialog.textInput);
                            }
                        }
                    }
                );

                this.$refs.TextInputDialog.title     = this.$t("saveGroup");
                this.$refs.TextInputDialog.hintText  = this.$t("groupName");
                this.$refs.TextInputDialog.textInput = this.groups.filter(data => data.id == this.selectedGroupId).length > 0
                    ? this.groups.filter(data => data.id == this.selectedGroupId)[0].name
                    : "";
                this.$refs.TextInputDialog.dialog    = true;
            },

            /**
             * Отображение диалога редактирования
             */
            editItem (item) {
                this.initLumberWatcher();
                this.$refs.EditLumberDialog.resetForm();
                this.$refs.EditLumberDialog.loadSpecies();
                this.$refs.EditLumberDialog.loadLengths();
                this.$refs.EditLumberDialog.loadLengthGroups();
                this.$refs.EditLumberDialog.loadLumberGroups();
                this.$refs.EditLumberDialog.species = {
                    id:      item.speciesId,
                    species: item.species
                };
                this.$refs.EditLumberDialog.boardType       = item.isCentralBoard ? 0 : 1;
                this.$refs.EditLumberDialog.dimensionId     = item.id;
                this.$refs.EditLumberDialog.Tn              = item.Tn;
                this.$refs.EditLumberDialog.Ts              = item.Ts;
                this.$refs.EditLumberDialog.Wn              = item.Wn;
                this.$refs.EditLumberDialog.Ws              = item.Ws;
                this.$refs.EditLumberDialog.selectedLengths = item.selectedLengths;
                this.$refs.EditLumberDialog.price           = item.price;
                this.$refs.EditLumberDialog.expenses        = item.expenses;
                this.$refs.EditLumberDialog.selectedLengthGroupId = 0;

                let selectedLumberGroupId = [];
                item.groups.forEach(groupName => {
                    let group = this.groups.filter( g => g.name == groupName);
                    if (group) {
                        selectedLumberGroupId.push(group[0].id);
                    }
                });
                this.$refs.EditLumberDialog.selectedLumberGroupId = selectedLumberGroupId;

                this.$refs.EditLumberDialog.dialog          = true;
            },

            /**
             * Инициализация наблюдения за состоянием флага изменения данных
             */
            initLumberWatcher () {
                if (this.lumberWatcher !== null) {
                    this.lumberWatcher();
                }

                /* Отслеживание состояния флага изменения данных */
                this.lumberWatcher = this.$watch(
                    "$refs.EditLumberDialog.dataUpdated",
                    async (val) => {
                        if (val) {
                            //this.dataSavedAlert = true;
                            this.alert = this.$t("dataSaved");
                            await this.loadLumber();
                            this.loadGroups();
                            this.selectedGroupId = 0;
                        }
                    }
                );
            },

            /**
             * Загрузка групп пиломатериалов
             */
            loadGroups () {
                this.loading.groups = true;

                this.axios.get(`${this.$config.apiURL}lumber_groups/`, { withCredentials: true })
                    .then(response => {
                        if (response.data.status == "success") {
                            let groups = response.data.groups;

                            this.groups = [];
                            if (this.enableToUpdateGroupList) {
                                        this.groupsList = [];
                            }
                            this.lumber.forEach(item => {
                                item.groups = [];
                            });

                            groups.forEach((item) => {
                                //if (item.Visible) {

                                    let lumberIds = [];

                                    item.LumberGroupsData.forEach(data => {
                                        lumberIds.push(parseInt(data.LumberId));
                                        let lum = this.lumber.find(l => l.id == parseInt(data.LumberId));
                                        lum.groups.push(item.Name);
                                    });

                                    this.groups.push({
                                        id:        item.id,
                                        name:      item.Name,
                                        speciesId: item.Species.id,
                                        lumberIds: lumberIds,
                                    });

                                    if (this.enableToUpdateGroupList) {
                                        this.groupsList.push({
                                            id:    item.id,
                                            title: item.Name
                                        });
                                    }

                                //}
                            });

                            this.enableToUpdateGroupList = false;
                        }

                        if (this.groups.filter(data => data.id == 0).length == 0) {
                            this.groups.unshift({
                                id:        0,
                                name:      this.$t("newGroup"),
                                speciesId: this.selectedSpeciesId,
                                lumberIds: [],
                            });
                            //this.selectedGroupId = 0;
                        }

                        this.loading.groups = false;
                    })
                    .catch(error => {
                        this.loading.groups = false;

                        if (error.response && error.response.status == 401) {
                            this.showMessageBox(this.$t("error"), this.$t("sessionExpired"));

                            // Удаление наблюдателя если установлен
                            if (this.dialogWatcher !== null) { this.dialogWatcher(); }

                            // Отслеживание нажатия кнопки ok в диалоге
                            this.dialogWatcher = this.$watch(
                                "$refs.MessageBox.dialog",
                                () => { window.location.reload(); }
                            );
                        } else if (error.response && error.response.status == 402) {
                            this.showMessageBox(this.$t("error"), this.$t("cantLoadGroupsData") + ". " + this.$t("subscriptionExpired"));

                            // Удаление наблюдателя если установлен
                            if (this.dialogWatcher !== null) { this.dialogWatcher(); }

                            // Отслеживание нажатия кнопки ok в диалоге
                            this.dialogWatcher = this.$watch(
                                "$refs.MessageBox.dialog",
                                () => { this.$emit("doLogout", true); }
                            );
                        } else if (error.response && error.response.status == 403 && typeof error.response.data !== "object" && error.response.data.trim() == "Access denied. Session id mismatch") {
                            this.showMessageBox(this.$t("error"), `${this.$t("accessDenied")}. ${this.$t("sessionIdMismatch")}.`);
                        } else if (error.response && error.response.status == 403) {
                            this.showMessageBox(this.$t("error"), this.$t("cantLoadGroupsData") + ". " + this.$t("accessDenied"));
                        } else {
                            this.showMessageBox(this.$t("error"), this.$t("cantLoadGroupsData"));
                        }
                    });
            },

            /**
             * Загрузка списка длин
             */
            loadLengths () {
                this.loading.lengths = true;

                this.axios.get(`${this.$config.apiURL}lengths/`, { withCredentials: true })
                    .then(response => {
                        if (response.data.status == "success") {
                            let lengthsInfo = response.data.lengths

                            this.lengthsList = [];

                            lengthsInfo.forEach((item) => {
                                //if (item.Visible) {
                                    this.lengthsList.push({
                                        id:    item.id,
                                        title: this.$num.dropZeros((item.Ln / 1000)) + " " + this.$t("m")
                                    });
                                //}
                            });
                        }

                        this.loading.lengths = false;
                    })
                    .catch(error => {
                        this.loading.lengths = false;

                        if (error.response && error.response.status == 401) {
                            this.showMessageBox(this.$t("error"), this.$t("sessionExpired"));

                            // Удаление наблюдателя если установлен
                            if (this.dialogWatcher !== null) { this.dialogWatcher(); }

                            // Отслеживание нажатия кнопки ok в диалоге
                            this.dialogWatcher = this.$watch(
                                "$refs.MessageBox.dialog",
                                () => { window.location.reload(); }
                            );
                        } else if (error.response && error.response.status == 402) {
                            this.showMessageBox(this.$t("error"), this.$t("cantLoadLengthsData") + ". " + this.$t("subscriptionExpired"));

                            // Удаление наблюдателя если установлен
                            if (this.dialogWatcher !== null) { this.dialogWatcher(); }

                            // Отслеживание нажатия кнопки ok в диалоге
                            this.dialogWatcher = this.$watch(
                                "$refs.MessageBox.dialog",
                                () => { this.$emit("doLogout", true); }
                            );
                        } else if (error.response && error.response.status == 403 && typeof error.response.data !== "object" && error.response.data.trim() == "Access denied. Session id mismatch") {
                            this.showMessageBox(this.$t("error"), `${this.$t("accessDenied")}. ${this.$t("sessionIdMismatch")}.`);
                        } else if (error.response && error.response.status == 403) {
                            this.showMessageBox(this.$t("error"), this.$t("cantLoadLengthsData") + ". " + this.$t("accessDenied"));
                        } else {
                            this.showMessageBox(this.$t("error"), this.$t("cantLoadLengthsData"));
                        }
                    });
            },

            /**
             * Загрузка справочника пиломатериалов
             */
            async loadLumber () {
                this.loading.lumber = true;

                await this.axios.get(`${this.$config.apiURL}lumber/`, { withCredentials: true })
                    .then(response => {
                        if (response.data.status == "success") {
                            let lumberInfo = response.data.lumber;

                            this.lumber         = [];
                            this.dimensionsList = [];
                            this.priceList      = [];
                            this.sawSizesList   = [];

                            lumberInfo.forEach((item) => {
                                //let boardType = dimensionInfo.IsCentralBoard ? dimensionsMan.$t("centralBoard") : dimensionsMan.$t("sideBoard");
                                let lengthsList = "";

                                JSON.parse(item.LengthsJSON).forEach((lenItem, index) => {
                                    lengthsList += index
                                        ? ", " + this.$num.dropZeros(lenItem.length.slice(0, -1))
                                        : lengthsList += this.$num.dropZeros(lenItem.length.slice(0, -1));
                                });

                                // Меняем значения стандартных сечений на ознакомительной подписке
                                if (this.$store.getters.subscription.id == 1) {
                                    item.Tn += 2;
                                    item.Wn += 2;
                                    item.Ts = parseFloat(item.Ts) + 2;
                                    item.Ws = parseFloat(item.Ws) + 2;
                                }

                                this.lumber.push({
                                    id:              item.id,
                                    speciesId:       item.Species.id,
                                    species:         this.$t(item.Species.Name),
                                    Tn:              item.Tn,
                                    Wn:              item.Wn,
                                    Ts:              item.Ts,
                                    Ws:              item.Ws,
                                    dimension:       item.Tn + " x " + item.Wn,
                                    sawSize:         item.Ts + " x " + item.Ws,
                                    //boardType:      item.BoardType,
                                    boardType:       item.BoardType == 0 ? this.$t("centralBoard") : this.$t("sideBoard"),
                                    isCentralBoard:  item.BoardType == 0,
                                    price:           item.Price,//.toString(),
                                    expenses:        item.Expenses == undefined ? 0 : item.Expenses,
                                    selectedLengths: JSON.parse(item.LengthsJSON),
                                    lengthsList:     lengthsList,
                                    groups:          []
                                });

                                let newDimension = true;

                                this.dimensionsList.forEach(element => {
                                    if (element.title == item.Tn + " x " + item.Wn) { newDimension = false; }
                                });

                                if (newDimension) {
                                    this.dimensionsList.push({
                                        id:    item.id,
                                        title: `${item.Tn} x ${item.Wn}`
                                    });
                                }

                                let newPrice = true;

                                this.priceList.forEach(element => {
                                    if (element.title == item.Price) { newPrice = true; }
                                });

                                if (newPrice) {
                                    this.priceList.push({
                                        id:    item.id,
                                        title: item.Price //.toString()
                                    });
                                }

                                let newSawSize = true;

                                this.sawSizesList.forEach(element => {
                                    if (element.title == `${item.Ts} x ${item.Ws}`) { newSawSize = false; }
                                });

                                if (newSawSize) {
                                    this.sawSizesList.push({
                                        id:    item.id,
                                        title: `${item.Ts} x ${item.Ws}`
                                    });
                                }
                            });

                            this.priceList.sort((a, b) => {
                                return parseFloat(a.title) - parseFloat(b.title);
                            });
                        }

                        this.loading.lumber = false;
                    })
                    .catch(error => {
                        this.loading.lumber = false;

                        if (error.response && error.response.status == 401) {
                            this.showMessageBox(this.$t("error"), this.$t("sessionExpired"));

                            // Удаление наблюдателя если установлен
                            if (this.dialogWatcher !== null) { this.dialogWatcher(); }

                            // Отслеживание нажатия кнопки ok в диалоге
                            this.dialogWatcher = this.$watch(
                                "$refs.MessageBox.dialog",
                                () => { window.location.reload(); }
                            );
                        } else if (error.response && error.response.status == 402) {
                            this.showMessageBox(this.$t("error"), this.$t("cantLoadLumberData") + ". " + this.$t("subscriptionExpired"));

                            // Удаление наблюдателя если установлен
                            if (this.dialogWatcher !== null) { this.dialogWatcher(); }

                            // Отслеживание нажатия кнопки ok в диалоге
                            this.dialogWatcher = this.$watch(
                                "$refs.MessageBox.dialog",
                                () => { this.$emit("doLogout", true); }
                            );
                        } else if (error.response && error.response.status == 403 && typeof error.response.data !== "object" && error.response.data.trim() == "Access denied. Session id mismatch") {
                            this.showMessageBox(this.$t("error"), `${this.$t("accessDenied")}. ${this.$t("sessionIdMismatch")}.`);
                        } else if (error.response && error.response.status == 403) {
                            this.showMessageBox(this.$t("error"), this.$t("cantLoadLumberData") + ". " + this.$t("accessDenied"));
                        } else {
                            this.showMessageBox(this.$t("error"), this.$t("cantLoadLumberData"));
                        }
                    });
            },

            /**
             * Загрузка списка пород
             */
            loadSpecies () {
                this.loading.species = true;

                this.axios.get(`${this.$config.apiURL}species/`, { withCredentials: true })
                    .then(response => {
                        if (response.data.status == "success") {
                            let speciesInfo = response.data.species

                            this.speciesList = [];

                            speciesInfo.forEach((item) => {
                                if (item.Visible) {
                                    this.speciesList.push({
                                        id:    item.id,
                                        title: this.$t(item.Name)
                                    });
                                }
                            });

                            this.speciesList.sort((a, b) => {
                                return a.title > b.title;
                            });
                        }

                        this.loading.species = false;
                    })
                    .catch(error => {
                        this.loading.species = false;

                        if (error.response && error.response.status == 401) {
                            this.showMessageBox(this.$t("error"), this.$t("sessionExpired"));

                            // Удаление наблюдателя если установлен
                            if (this.dialogWatcher !== null) { this.dialogWatcher(); }

                            // Отслеживание нажатия кнопки ok в диалоге
                            this.dialogWatcher = this.$watch(
                                "$refs.MessageBox.dialog",
                                () => { window.location.reload(); }
                            );
                        } else if (error.response && error.response.status == 402) {
                            this.showMessageBox(this.$t("error"), this.$t("cantLoadSpeciesData") + ". " + this.$t("subscriptionExpired"));

                            // Удаление наблюдателя если установлен
                            if (this.dialogWatcher !== null) { this.dialogWatcher(); }

                            // Отслеживание нажатия кнопки ok в диалоге
                            this.dialogWatcher = this.$watch(
                                "$refs.MessageBox.dialog",
                                () => { this.$emit("doLogout", true); }
                            );
                        } else if (error.response && error.response.status == 403 && typeof error.response.data !== "object" && error.response.data.trim() == "Access denied. Session id mismatch") {
                            this.showMessageBox(this.$t("error"), `${this.$t("accessDenied")}. ${this.$t("sessionIdMismatch")}.`);
                        } else if (error.response && error.response.status == 403) {
                            this.showMessageBox(this.$t("error"), this.$t("cantLoadSpeciesData") + ". " + this.$t("accessDenied"));
                        } else {
                            this.showMessageBox(this.$t("error"), this.$t("cantLoadSpeciesData"));
                        }
                    });
            },

            /**
             * Сброс фильтров
             */
            resetFilters () {
                this.filters.boardType = [];
                this.filters.dimension = [];
                this.filters.lengths   = [];
                this.filters.sawSize   = [];
                this.filters.species   = [];
                this.filters.groups    = [];
            },

            /**
             * Сброс фильтров групп
             */
            resetGroupsFilters () {
                this.groupsFilters.boardType = [];
                this.groupsFilters.dimension = [];
                this.groupsFilters.lengths   = [];
                this.groupsFilters.sawSize   = [];
                //this.groupsFilters.species   = [];
            },

            /**
             * Перезагрузка списка пиломатариалов и групп
             */
            async reloadLumbers () {
                this.resetFilters();
                this.enableToUpdateGroupList = true;
                await this.loadLumber();
                this.loadGroups();
            },

            /**
             * Сохраняет группу пиломатериалов с новым названием
             *
             * @param {string} name Название группы
             */
            saveGroupAs (name) {
                let items = [];

                this.groupItems.forEach(item => {
                    items.push(item.id);
                });

                this.axios({
                    method: "post",
                    url: `${this.$config.apiURL}lumber_groups/`,
                    data: {
                        name:      name,
                        speciesId: this.selectedSpeciesId,
                        dataJSON:  JSON.stringify(items)
                    },
                    withCredentials: true
                }).then(response => {
                    if (response.status == 200 ) {
                        if (response.data.status == "attention") {
                            this.showMessageBox(this.$t("error"), this.$t("cantSaveLumberGroup"));
                        } else {
                            this.alertType   = "success";
                            this.alert       = this.$t("lumberGroupSaved");
                            //this.dataUpdated = true;
                            //this.lineChanged = false;
                            this.resetFilters();
                            this.enableToUpdateGroupList = true;
                            this.loadGroups();
                        }
                    }
                }).catch(error => {
                    if (error.response && error.response.status == 401) {
                        this.showMessageBox(this.$t("error"), this.$t("sessionExpired"));

                        // Удаление наблюдателя если установлен
                        if (this.dialogWatcher !== null) { this.dialogWatcher(); }

                        // Отслеживание нажатия кнопки ok в диалоге
                        this.dialogWatcher = this.$watch(
                            "$refs.MessageBox.dialog",
                            () => { window.location.reload(); }
                        );
                    } else if (error.response && error.response.status == 402) {
                        this.showMessageBox(this.$t("error"), this.$t("cantSaveLumberGroup") + ". " + this.$t("subscriptionExpired"));

                        // Удаление наблюдателя если установлен
                        if (this.dialogWatcher !== null) { this.dialogWatcher(); }

                        // Отслеживание нажатия кнопки ok в диалоге
                        this.dialogWatcher = this.$watch(
                            "$refs.MessageBox.dialog",
                            () => { this.$emit("doLogout", true); }
                        );
                    } else if (error.response && error.response.status == 403 && typeof error.response.data !== "object" && error.response.data.trim() == "Access denied. Session id mismatch") {
                        this.showMessageBox(this.$t("error"), `${this.$t("accessDenied")}. ${this.$t("sessionIdMismatch")}.`);
                    } else if (error.response && error.response.status == 403) {
                        this.showMessageBox(this.$t("error"), this.$t("cantSaveLumberGroup") + ". " + this.$t("accessDenied"));
                    } else {
                        this.showMessageBox(this.$t("error"), this.$t("cantSaveLumberGroup"));
                    }
                });
            },

            /**
             * Обработчик нажатия кнопки сохранения группы под новым именем
             */
            saveGroupAsClick () {
                if (this.dialogWatcher !== null) {
                    this.dialogWatcher();
                }

                this.dialogWatcher = this.$watch(
                    "$refs.TextInputDialog.answer",
                    (val) => {
                        if (val) {
                            if (this.$refs.TextInputDialog.textInput.trim() == "") {
                                this.$refs.MessageBox.title       = this.$t("error");
                                this.$refs.MessageBox.messageText = this.$t("groupNameCantBeEmpty");
                                this.$refs.MessageBox.dialog      = true;
                            } else {
                                this.saveGroupAs(this.$refs.TextInputDialog.textInput);
                            }
                        }
                    }
                );

                this.$refs.TextInputDialog.title     = this.$t("saveGroup");
                this.$refs.TextInputDialog.hintText  = this.$t("groupName");
                this.$refs.TextInputDialog.textInput = this.groups.filter(data => data.id == this.selectedGroupId).length > 0
                    ? this.groups.filter(data => data.id == this.selectedGroupId)[0].name
                    : "";
                this.$refs.TextInputDialog.dialog    = true;
            },

            /**
             * Обработчик нажатия кнопки сохранения группы
             *
             * @param {string} newName Новое название группы
             */
            saveGroupClick (newName = null) {
                let items = [];
                let name  = this.groups.filter(data => data.id == this.selectedGroupId).length > 0
                    ? this.groups.filter(data => data.id == this.selectedGroupId)[0].name
                    : "";

                if (name.trim() == "") {
                    this.saveGroupAsClick();
                    return;
                }

                this.groupItems.forEach(item => {
                    items.push(item.id);
                });

                this.axios({
                    method: "patch",
                    url: `${this.$config.apiURL}lumber_groups/${this.selectedGroupId}/`,
                    data: {
                        name: newName == null || newName.trim() == ""
                            ? name
                            : newName,
                        speciesId: this.selectedSpeciesId,
                        dataJSON:  JSON.stringify(items)
                    },
                    withCredentials: true
                }).then(response => {
                    if (response.status == 200 ) {
                        if (response.data.status == "attention") {
                            this.showMessageBox(this.$t("error"), this.$t("cantSaveLumberGroup"));
                        } else {
                            this.alertType   = "success";
                            this.alert       = this.$t("lumberGroupSaved");
                            //this.dataUpdated = true;
                            //this.lineChanged = false;
                            this.resetFilters();
                            this.enableToUpdateGroupList = true;
                            this.loadGroups();
                        }
                    }
                }).catch(error => {
                    if (error.response && error.response.status == 401) {
                        this.showMessageBox(this.$t("error"), this.$t("sessionExpired"));

                        // Удаление наблюдателя если установлен
                        if (this.dialogWatcher !== null) { this.dialogWatcher(); }

                        // Отслеживание нажатия кнопки ok в диалоге
                        this.dialogWatcher = this.$watch(
                            "$refs.MessageBox.dialog",
                            () => { window.location.reload(); }
                        );
                    } else if (error.response && error.response.status == 402) {
                        this.showMessageBox(this.$t("error"), this.$t("cantSaveLumberGroup") + ". " + this.$t("subscriptionExpired"));

                        // Удаление наблюдателя если установлен
                        if (this.dialogWatcher !== null) { this.dialogWatcher(); }

                        // Отслеживание нажатия кнопки ok в диалоге
                        this.dialogWatcher = this.$watch(
                            "$refs.MessageBox.dialog",
                            () => { this.$emit("doLogout", true); }
                        );
                    } else if (error.response && error.response.status == 403 && typeof error.response.data !== "object" && error.response.data.trim() == "Access denied. Session id mismatch") {
                        this.showMessageBox(this.$t("error"), `${this.$t("accessDenied")}. ${this.$t("sessionIdMismatch")}.`);
                    } else if (error.response && error.response.status == 403) {
                        this.showMessageBox(this.$t("error"), this.$t("cantSaveLumberGroup") + ". " + this.$t("accessDenied"));
                    } else {
                        this.showMessageBox(this.$t("error"), this.$t("cantSaveLumberGroup"));
                    }
                });
            },

            /**
             * Отображает сообщение
             *
             * @param {string} title       Заголовок
             * @param {string} messageText Текст сообщения
             */
            showMessageBox (title, messageText) {
                this.$refs.MessageBox.title       = title;
                this.$refs.MessageBox.messageText = messageText;
                this.$refs.MessageBox.dialog      = true;
            },

            /**
             * Отображение диалога добавления пиломатериала
             */
            showNewLumberDlg () {
                this.initLumberWatcher();
                this.$refs.EditLumberDialog.resetForm();
                this.$refs.EditLumberDialog.loadSpecies();
                this.$refs.EditLumberDialog.loadLengths();
                this.$refs.EditLumberDialog.loadLengthGroups();
                this.$refs.EditLumberDialog.loadLumberGroups();
                this.$refs.EditLumberDialog.selectedLengthGroupId = 0;
                this.$refs.EditLumberDialog.selectedLumberGroupId = [];
                this.$refs.EditLumberDialog.dialog = true;
            },

            toggleAll () {
                this.groupItems = this.groupItems.length ? [] : this.filteredLumber.slice();
            },

            spaceClickedInSearch () {
                this.lumberSearch += "x ";
            }
        }
    }
</script>

<style lang="sass" scoped>
    .layout.md-up
        .v-scrollable
            overflow-y: auto
            max-height: calc(100dvh - 192px)
        .v-scrollable-groups
            overflow-y: auto
            max-height: calc(100dvh - 256px)

    .search-field
        max-width: 250px
        margin-right: 16px
</style>
